import { render, staticRenderFns } from "./iconPlus.vue?vue&type=template&id=1d43056e"
import script from "./iconPlus.vue?vue&type=script&lang=js"
export * from "./iconPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports